import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@niko-crm/ui';

/**
 * `/unauthorized` only makes sense for a signed-in user who is NOT a
 * SuperAdmin. It was previously public, so an anonymous visitor saw a dead-end
 * page with a logout link and no session to log out of, and a SuperAdmin who
 * typed the URL saw a denial that did not apply to them.
 */
export const unauthorizedGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const payload = await authService.getTokenPayload();
  if (!payload) return router.createUrlTree(['/login']);

  const groups = (payload['cognito:groups'] as string[]) ?? [];
  return groups.includes('SuperAdmin') ? router.createUrlTree(['/tenants']) : true;
};
